"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _dateFormatDestination = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/dateFormatDestination"));

var _common = require("@insided/shared/utils/common");

var DateTimeWithTooltip = function DateTimeWithTooltip(props) {
  var replyTime = props.replyTime;
  return (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    trigger: (0, _preact.h)("time", {
      dateTime: new Date(replyTime).toISOString()
    }, _common.common.relativeDate(replyTime)),
    tooltipMessage: (0, _preact.h)("div", {
      className: (0, _classnames.default)('tooltip__content', 'tooltip__content--publish-date', 'js-tooltip-content', 'position--bottom')
    }, (0, _dateFormatDestination.default)(replyTime))
  });
};

var _default = DateTimeWithTooltip;
exports.default = _default;